import React from 'react';
import Logo from "../assets/logo-largo-color.png";
import HelpIcon from "@material-ui/icons/Help";
import IconButton from "@material-ui/core/IconButton";
import ManualUsuario from '../assets/manual_usuario_pqr.pdf'

class Header extends React.Component {

    render() {

        return (
            <div style={{textAlign: 'center', height: '115px'}}>
                <img alt='logo' className='logo-largo' src={Logo} style={{width: '30%'}}/>

                <a href={ManualUsuario} target='_blank' rel="noopener noreferrer">
                    <IconButton color="primary" style={{marginBottom: '40px'}}>
                        <HelpIcon fontSize='large'/>
                    </IconButton>
                </a>

            </div>
        );


    }
}

export default Header